import { connect } from "react-redux";

import Product from "../../components/product/product";

import { getAllProducts } from "./selectors";

function ProductList(props) {
  return (
    <div>
      {props.products.map((product) => (
        <Product key={product.sku} product={product} />
      ))}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    products: getAllProducts(state),
  };
};

export default connect(mapStateToProps, null)(ProductList);
